import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { SessionQuery } from '@app/core'

export const notAuthenticatedGuard: CanActivateFn = () => {
  const router = inject(Router)
  const session = inject(SessionQuery)

  if (session.isLoggedIn()) {
    return router.parseUrl('/')
  }

  return true
}
